import { CheckIcon } from '@shared/custom-icons';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from 'react-router';
import { Box, Stack, Typography } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  url?: string;
}

export const DownloadDocumentationLink = ({ url = '' }: Props) => {
  const t = useProductsTFunction();

  return (
    <Link to={url} target="_blank" download>
      <Stack alignItems="center" gap={0.5}>
        <CheckIcon fontSize="small" />

        <Box display="flex" alignItems="center" gap={0.5}>
          <OpenInNewIcon fontSize="small" />
          <Typography variant="body2">{t('products.mgItem.documentation.download')}</Typography>
        </Box>
      </Stack>
    </Link>
  );
};
